module.exports = __webpack_public_path__ + "static/DEV5-cc779cb1fc7792061af7829e18bf44bf.png";